let col_handle="",
	col_id="",
   	col_title="",
	col_url="",
	nextlink="",
	image_embed="", 
	image="",
	title="",
	cart="",
	price=0,
    maxprice=0,
    hasParam=false,
	ProductsHTML = "",
	product_data={},
	alltagsArr = [];
	tagsArr = {};
let filter_tags=null,
	filter_sort="";
var base_url="https://shop.penskeshocks.com";
 
/* Collection filter  */
if(is_collection){
    jQuery(document).ready(function () {
  /* Filter Category accordian */
        jQuery(".collapsible").on("click", function () {
            if (jQuery(this).hasClass("no__collapse")) {
              window.location.href=jQuery(this).attr("data-col-url");
              return;
            }
            if ((jQuery(this).toggleClass("active"), jQuery(this).hasClass("active"))) {
                jQuery(".collapsible").removeClass("active"), jQuery(this).addClass("active");
                var e = jQuery(this).next();
                jQuery(".dev-container .content").attr("style", "max-height:0"), e.attr("style", "max-height:" + e.prop("scrollHeight") + "px");
            } else 
            {
              jQuery(".dev-container .collapsible").removeClass("active");
               jQuery(".dev-container .content").attr("style", "max-height:0");
            }
        });
		var is_mobile = false;
	   if($(window).width()<=1024){
		 
		  is_mobile = true;       
		}
              jQuery('.collapsible').each(function(i, obj) {
              var $collapsebtn=jQuery(this);
              var contentID="#"+jQuery(this).attr("data-contentID");
              var $collapseContent=jQuery(contentID);
              if(jQuery(".main_sidemenu_item",$collapseContent).length==0){
                $collapsebtn.addClass("no__collapse");
                
              }else if(jQuery(".main_sidemenu_item.active",$collapseContent).length!=0){
				  if (is_mobile == false) { 
						$collapsebtn.trigger("click");
				  }
              }else if(jQuery(".child_sidemenu_item.active",$collapseContent).length!=0){
					if (is_mobile == false) { 
						$collapsebtn.trigger("click");
				  }
                jQuery(".child_sidemenu_item.active",$collapseContent).closest(".main_sidemenu_item").addClass("active");
              }else if(jQuery(".grandchild_sidemenu_item.active",$collapseContent).length!=0){
				  if (is_mobile == false) { 
						$collapsebtn.trigger("click");
				  }
				  jQuery(".grandchild_sidemenu_item.active",$collapseContent).closest(".main_sidemenu_item").addClass("active");
                jQuery(".grandchild_sidemenu_item.active",$collapseContent).closest(".child_sidemenu_item").addClass("active");
              }
          });
    
    if (is_mobile == false) { 
           if(jQuery('.collapsible[data-mainhandle="'+defaultCollection.handle+'"]:not(.no__collapse)').length!=0){
            // jQuery('.collapsible[data-mainhandle="'+defaultCollection.handle+'"]').trigger("click");
          }
    }
    });
  
  /*==== 1) Default Filter Checks the Collection Page has Parameter or Subcategory   =====*/
  function defaultcollection_filterapply(){
				jQuery(".products-subcat").hide();
				jQuery(".products-result").hide();
				jQuery("#pagination-container").hide();
				jQuery(".sidebar-tags-container").hide();
			col_id=collection_id;
    		col_handle=defaultCollection.handle;
        	col_title=defaultCollection.title;
			coll__desc=defaultCollection.body_html;
          col_url=base_url+"/collections/"+col_handle+"/products.json?limit=250&published_status=published&collection_id="+col_id;
    	
               jQuery("#loading").show();
             
          var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              var allProducts = JSON.parse(this.responseText).products;
               ProductsHTML = "";
              
              for (i = 0; i < allProducts.length; i++) {
                if(allProducts[i].options.length==1){
                 if(allProducts[i].options[0].values[0]=="Default Title"){
                 ProductsHTML += get_simpleHtml(allProducts[i]);
                   }else{
                      ProductsHTML += get_variantHtml(allProducts[i]);
                  }
                }else{
                ProductsHTML += get_variantHtml(allProducts[i]);
                }
              }

              var coll_title_html='<div class="col-head-item col-12"><h3 class="coll__title">'+col_title+'</h3></div>';
              var sortfilterHtml=get_sort_filterHtml();
              var head_Html=coll_title_html+sortfilterHtml;
                 jQuery(".products-result").html(head_Html);

                  jQuery(".products-result").append(ProductsHTML);
                  jQuery("#loading").hide();
                  get__sort__filter();
               alltagsArr.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
				  var TagHTML = '<div class="tags_checkbox">';
				 for (tt = 0; tt < alltagsArr.length; tt++) {
						 if(filter_tags!=null) {
							 if($.inArray(alltagsArr[tt], filter_tags.toString().split(',')) == -1) {
							TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							 }else{
								TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item' checked>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							}
						}else{
							
						TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
						}
					}
				  
              		TagHTML += '</div>';
                  //createTagsHtml(TagHTML);

              if(jQuery("body .products-subcat .grid-item").length==0 || hasParam==true){
                              //  alert();
					filter_Apply(false,true);
              }else{
				  jQuery(".products-subcat").show();
				  /* Read More Description Functionality  */
					createViewMoreCollection();
			  }
            }
          });
          xhr.open("GET", col_url);
          xhr.send();
  }
  
  
  jQuery(document).ready(function(){
	 /*==== 2) Checks The paramter in the current url   =====*/
    var currPageUrl = window.location.href;
     var urlParams = new URLSearchParams(currPageUrl.replace(/&amp;/g, "&"));
       console.log(urlParams);
    if(urlParams.has('filter_tags') && urlParams.get('filter_tags')!=null ){  // Checking paramter tags
     
        filter_tags= urlParams.get('filter_tags'); 
          hasParam=true;
    } 
    const theparams = new Proxy(new URLSearchParams(window.location.search), {
      get: (searchParams, prop) => searchParams.get(prop),
    });

    if(theparams.filter_tags && theparams.filter_tags!=null ){ 
        filter_tags= theparams.filter_tags; 
         hasParam=true;

    }
        if(urlParams.has('filter_sort') && urlParams.get('filter_sort')!=null ){ // Checking paramter sort by
            filter_sort= urlParams.get('filter_sort'); 
              hasParam=true;
        }

    /*if((urlParams.has('start_price') && urlParams.get('start_price')!="")&& (urlParams.has('end_price') && urlParams.get('end_price')!="") ){
         // Checking paramter Satrt and End price
		 filter_start_price= urlParams.get('start_price');  
           filter_end_price= urlParams.get('end_price'); 
        jQuery(".price_start").val(filter_start_price);
        jQuery(".price_end").val(filter_end_price);
          hasParam=true;
    }*/
  
  defaultcollection_filterapply(); // executing default filter
 
     /*==== 3) On click Side bar menu 1 ajax   =====*/
    jQuery(".main_sidemenu_link").on("click",function(e){
          e.preventDefault();    
			jQuery(".products-subcat").hide();
			jQuery(".products-result").hide();
			jQuery("#pagination-container").hide();
			jQuery(".sidebar-tags-container").hide();
          jQuery("#loading").show();
		  	alltagsArr = [];

			tagsArr = {};

          //jQuery(".main_sidemenu_item").removeClass("active"); 
          jQuery(".main_sidemenu_item li").removeClass("active"); 

          jQuery(this).parent("li").addClass("active"); 

          col_id=jQuery(this).attr("data-col-id");
      		col_handle=jQuery(this).attr("data-col-handle");
              	col_title=jQuery(this).attr("data-col-title");
                coll__desc=jQuery(".coll__desc[data-col-id='"+col_id+"']").html();;


         col_url=base_url+"/collections/"+col_handle+"/products.json?limit=250&published_status=published&collection_id="+col_id;
           var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              var allProducts = JSON.parse(this.responseText).products;
              console.log(allProducts);
               ProductsHTML = "";

              for (i = 0; i < allProducts.length; i++) {
                if(allProducts[i].options.length==1){
                 if(allProducts[i].options[0].values[0]=="Default Title"){
                 ProductsHTML += get_simpleHtml(allProducts[i]);
                   }else{
                      ProductsHTML += get_variantHtml(allProducts[i]);
                  }
                }else{
                ProductsHTML += get_variantHtml(allProducts[i]);
                }
              }
                  var coll_title_html='<div class="col-head-item col-12"><h3 class="coll__title">'+col_title+'</h3><div class="rte collection-content">'+coll__desc+'</div></div>';
                  var sortfilterHtml=get_sort_filterHtml();
              var head_Html=coll_title_html+sortfilterHtml;
                 jQuery(".products-result").html(head_Html);
                  jQuery(".products-result").append(ProductsHTML);
                  get__sort__filter();
              alltagsArr.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});

				  var TagHTML = '<div class="tags_checkbox">';
					 for (tt = 0; tt < alltagsArr.length; tt++) {
						 if(filter_tags!=null) {
							 if($.inArray(alltagsArr[tt], filter_tags.toString().split(',')) == -1) {
							TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							 }else{
								TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item' checked>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							}
						}else{
							
						TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
						}
					}
				  
              		TagHTML += '</div>';
                  //createTagsHtml(TagHTML);
					filter_Apply(false);
            }
          });
          xhr.open("GET", col_url);
          xhr.send();
     
     });

     /*==== 4) On click Side bar menu 2 ajax   =====*/
      jQuery(".child_sidemenu_link").on("click",function(e){
          e.preventDefault();    
			jQuery(".products-subcat").hide();
			jQuery(".products-result").hide();
			jQuery("#pagination-container").hide();
			jQuery(".sidebar-tags-container").hide();
          jQuery("#loading").show();
		  	alltagsArr = [];

		  tagsArr = {};

          //jQuery(".child_sidemenu_item").removeClass("active"); 
          jQuery(this).parent("li").addClass("active"); 

          col_id=jQuery(this).attr("data-col-id");
          col_handle=jQuery(this).attr("data-col-handle");
			col_title=jQuery(this).attr("data-col-title");
                coll__desc=jQuery(".coll__desc[data-col-id='"+col_id+"']").html();;

          col_url=base_url+"/collections/"+col_handle+"/products.json?limit=250&published_status=published&collection_id="+col_id;
            var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              var allProducts = JSON.parse(this.responseText).products;
              console.log(allProducts);
                ProductsHTML = "";
              for (i = 0; i < allProducts.length; i++) {
                if(allProducts[i].options.length==1){
                 if(allProducts[i].options[0].values[0]=="Default Title"){
                 ProductsHTML += get_simpleHtml(allProducts[i]);
                   }else{
                      ProductsHTML += get_variantHtml(allProducts[i]);
                  }
                }else{
                ProductsHTML += get_variantHtml(allProducts[i]);
                }
              }
					var coll_title_html='<div class="col-head-item col-12"><h3 class="coll__title">'+col_title+'</h3><div class="rte collection-content">'+coll__desc+'</div></div>';
                  var sortfilterHtml=get_sort_filterHtml();
              var head_Html=coll_title_html+sortfilterHtml;
                 jQuery(".products-result").html(head_Html);

                  jQuery(".products-result").append(ProductsHTML);
                  get__sort__filter();
              alltagsArr.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
				     var TagHTML = '<div class="tags_checkbox">';
				 for (tt = 0; tt < alltagsArr.length; tt++) {
                      if(filter_tags!=null) {
							 if($.inArray(alltagsArr[tt], filter_tags.toString().split(',')) == -1) {
							TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							 }else{
								TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item' checked>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							}
						}else{
							
						TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
						}
					}
				  
              		TagHTML += '</div>';
                  //createTagsHtml(TagHTML);
				  filter_Apply(false);
              
            }
          });
          xhr.open("GET", col_url);
          xhr.send();
     });
	 
	      /*==== 5) On click Side bar menu 3 ajax   =====*/
	jQuery(".grandchild_sidemenu_link").on("click",function(e){
          e.preventDefault();    
			jQuery(".products-subcat").hide();
			jQuery(".products-result").hide();
			jQuery("#pagination-container").hide();
			jQuery(".sidebar-tags-container").hide();
          jQuery("#loading").show();
		  	alltagsArr = [];

		  tagsArr = {};

          //jQuery(".grandchild_sidemenu_item").removeClass("active"); 
          jQuery(this).parent("li").addClass("active"); 

          col_id=jQuery(this).attr("data-col-id");
          col_handle=jQuery(this).attr("data-col-handle");
			col_title=jQuery(this).attr("data-col-title");
                coll__desc=jQuery(".coll__desc[data-col-id='"+col_id+"']").html();

          col_url=base_url+"/collections/"+col_handle+"/products.json?limit=250&published_status=published&collection_id="+col_id;
            var xhr = new XMLHttpRequest();
          xhr.withCredentials = true;
          xhr.addEventListener("readystatechange", function() {
            if(this.readyState === 4) {
              var allProducts = JSON.parse(this.responseText).products;
              console.log(allProducts);
                ProductsHTML = "";
              for (i = 0; i < allProducts.length; i++) {
                if(allProducts[i].options.length==1){
                 if(allProducts[i].options[0].values[0]=="Default Title"){
                 ProductsHTML += get_simpleHtml(allProducts[i]);
                   }else{
                      ProductsHTML += get_variantHtml(allProducts[i]);
                  }
                }else{
                ProductsHTML += get_variantHtml(allProducts[i]);
                }
              }
					var coll_title_html='<div class="col-head-item col-12"><h3 class="coll__title">'+col_title+'</h3><div class="rte collection-content">'+coll__desc+'</div></div>';
                  var sortfilterHtml=get_sort_filterHtml();
              var head_Html=coll_title_html+sortfilterHtml;
                 jQuery(".products-result").html(head_Html);

                  jQuery(".products-result").append(ProductsHTML);
            
                  get__sort__filter();
               alltagsArr.sort(function (a, b) {
				return a.toLowerCase().localeCompare(b.toLowerCase());
			});
				    var TagHTML = '<div class="tags_checkbox">';
				 for (tt = 0; tt < alltagsArr.length; tt++) {
                      if(filter_tags!=null) {
							 if($.inArray(alltagsArr[tt], filter_tags.toString().split(',')) == -1) {
							TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							 }else{
								TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item' checked>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
							}
						}else{
							
						TagHTML += "<div class='tag-data'><input type='checkbox' value='"+alltagsArr[tt]+"'  class='tag-item'>"+alltagsArr[tt]+" ("+tagsArr[alltagsArr[tt]]+")</div>";
						}
					}
				  
              		TagHTML += '</div>';
                  //createTagsHtml(TagHTML);
					filter_Apply(false);
            }
          });
          xhr.open("GET", col_url);
          xhr.send();
     });
	 
	 /*==== 6) create Price range slider   =====*/	 
	/* const slider = document.getElementById('sliderPrice');
	const step = parseInt(slider.dataset.step);
	const filterInputs = document.querySelectorAll('input.filter__input_price');
	var start_price = jQuery('#sliderPrice').attr('data-start');
	var start_end = jQuery('#sliderPrice').attr('data-end');
	var slprice = noUiSlider.create(slider, {
		  start: [filter_start_price, filter_end_price],
		  connect: true,
		  step: step,

		  range: {
			  'min': rangeMin,
			  'max': rangeMax
		  },

		  // make numbers whole
		  format: {
			to: value => parseFloat(value).toFixed(2),
			from: value => parseFloat(value).toFixed(2)
		  }
	});
	// bind inputs with noUiSlider 
	slider.noUiSlider.on('update', (values, handle) => { 
	filterInputs[handle].value = values[handle]; 
	});
	slider.noUiSlider.on('set.one', (values, handle) => { 
	filter_Apply(true);
	});

	filterInputs.forEach((input, indexInput) => { 
		input.addEventListener('change', () => {
		  slider.noUiSlider.setHandle(indexInput, input.value);
		})
	}); */

});

// Price slider Input

 /*==== 7) Create Html Of Sort by DropDown =====*/	 
function get_sort_filterHtml(){
  var the_html="";
    the_html += '<div class="col-head-item col_selected_filter col-4"></div><div class="col-head-item col-4"><div class="row"><div class="col-6"><strong>Items Per Page </strong></div><div class="col-6"><select name="itemsperpage" class="itemsperpage"><option value="10">10</option><option value="20">20</option><option value="30">30</option><option value="40">40</option><option value="50">50</option></select></div></div></div><div class="col-head-item col-4"><div class="row"><div class="col-4"><strong>Sort by </strong></div><div class="col-8"><select name="orderby" class="order__by" aria-label="Shop order">';
              the_html += getsortedoption("title_asc","Title: (A-Z)");
                the_html += getsortedoption("title_desc","Title: (Z-A)");
              the_html += getsortedoption("latest","Latest");
              the_html += getsortedoption("price_asc","Price: Low to High");
              the_html += getsortedoption("price_desc","Price: High to Low");
              the_html += '</select></div></div></div>';
      return the_html;
}

 /*==== 7) Create Html Of filtered result  1 =====*/	 
function get_simpleHtml(product){
		//var alltags_array = product.tags.split(',');
		var alltags_array = product.tags;
   var prd__tags="";
			for(var t = 0; t < alltags_array.length; t++) {	
      var tag_value=alltags_array[t].trim();
	  if(tag_value!=null && tag_value!=""){
        tag_value=convertToSlug(tag_value)
        prd__tags+=tag_value+",";
	  if (!alltagsArr.includes(tag_value)) {
			  alltagsArr.push(tag_value);
			}
		   if (!tagsArr[tag_value]) {
			  tagsArr[tag_value]=1;
			}else{
				tagsArr[tag_value]=tagsArr[tag_value]+1;
			}
	  }
	}
	var the_html="";
   price=get__price(product.variants);
  			 maxprice=get__maxprice(product.variants);
			var compareAtPrice = null;
			for (var v = 0; v < product.variants.length; v++) {
			  var cap = product.variants[v].compare_at_price;
			  if (cap != null && parseFloat(cap) > parseFloat(price)) {
			    compareAtPrice = parseFloat(cap);
			    break;
			  }
			}
			var priceHtml;
			if (compareAtPrice != null && compareAtPrice > price) {
			  priceHtml = '<span class="special-price">'+getCurrencyPrice(price)+'</span>' +
			    ' <span class="old-price">'+getCurrencyPrice(compareAtPrice)+'</span>';
			} else {
			  priceHtml = getCurrencyPrice(price);
			  if (maxprice != 0 && maxprice != price) {
			    priceHtml += " - " + getCurrencyPrice(maxprice);
			  }
			}
    title = product.title;
					 images = product.images;
                 var imageCount = jQuery(images).length;
                jQuery(images).each(function (j, image) {
                  if (j == imageCount - 1) {
                     image_embed = '<div><img src="'+image.src+'" alt="'+title+'"></div>';
                    image_embed = image_embed.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png');
                  } else {
                     image_embed = '<div class="prd__img"><img src="'+image.src+'"></div>';
                    image_embed = image_embed.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png');
                  }
                });
                  the_html += "<div class='prd__box grid-item col-6 col-md-4' data-listing-price='"+price+"' data-listing-tags='"+prd__tags+"' data-listing-date='"+dateto_timestamp(product.published_at)+"' data-listing-title='"+title+"'>";
                  the_html += '<a class="add_option_tourl" href="/collections/'+col_handle+'/products/'+product.handle+'" ><div class="content-box">';
                  the_html += image_embed;
                  the_html += '<h3 class="banner-title">'+title+'</h3>';
                  the_html += '</div></a>';

            the_html += '<div class="option__row"><div class="option__col"><a class="add_option_tourl" href="/collections/'+col_handle+'/products/'+product.handle+'">View Details</a><h4 class="banner-price" >'+priceHtml+'</h4></div></div>';
                  the_html += '</div>';
                  return the_html;
}
  
   /*==== 8) Create Html Of filtered result  2 =====*/	 
function get_variantHtml(product){
  console.log(product);
		//var alltags_array = product.tags.split(',');
		var alltags_array = product.tags;
    var prd__tags="";
	for(var t = 0; t < alltags_array.length; t++) {	
      var tag_value=alltags_array[t].trim();
	  if(tag_value!=null && tag_value!=""){
        tag_value=convertToSlug(tag_value);
        prd__tags+=tag_value+",";
	  if (!alltagsArr.includes(tag_value)) {
			  alltagsArr.push(tag_value);
			}
		   if (!tagsArr[tag_value]) {
			  tagsArr[tag_value]=1;
			}else{
				tagsArr[tag_value]=tagsArr[tag_value]+1;
			}
	  }
	}
		  var the_html="";
			 price=get__price(product.variants);
  			 maxprice=get__maxprice(product.variants);
			var compareAtPrice = null;
			for (var v = 0; v < product.variants.length; v++) {
			  var cap = product.variants[v].compare_at_price;
			  if (cap != null && parseFloat(cap) > parseFloat(price)) {
			    compareAtPrice = parseFloat(cap);
			    break;
			  }
			}
			var priceHtml;
			if (compareAtPrice != null && compareAtPrice > price) {
			  priceHtml = '<span class="special-price">'+getCurrencyPrice(price)+'</span>' +
			    ' <span class="old-price">'+getCurrencyPrice(compareAtPrice)+'</span>';
			} else {
			  priceHtml = getCurrencyPrice(price);
			  if (maxprice != 0 && maxprice != price) {
			    priceHtml += " - " + getCurrencyPrice(maxprice);
			  }
			}
			title = product.title;
			 images = product.images;
			 var imageCount = jQuery(images).length;
			jQuery(images).each(function (j, image) {
			  if (j == imageCount - 1) {
				 image_embed = '<div><img src="'+image.src+'"></div>';
				image_embed = image_embed.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png');
			  } else {
				 image_embed = '<div class="prd__img"><img src="'+image.src+'"></div>';
				image_embed = image_embed.replace('.jpg', '_300x.jpg').replace('.png', '_300x.png');
			  }
			});
                
            the_html += "<div class='prd__box grid-item col-6 col-md-4' data-listing-price='"+price+"' data-listing-tags='"+prd__tags+"' data-listing-date='"+dateto_timestamp(product.published_at)+"' data-listing-title='"+title+"'>";
            the_html += '<a class="add_option_tourl" href="/collections/'+col_handle+'/products/'+product.handle+'" ><div class="content-box">';
            the_html += image_embed;
            the_html += '<h3 class="banner-title" >'+title+'</h3>';
            the_html += '</div></a>';
            the_html += '<div class="option__row"><div class="option__col"><a class="add_option_tourl" href="/collections/'+col_handle+'/products/'+product.handle+'">View Details</a><h4 class="banner-price" >'+priceHtml+'</h4></div></div>';

            the_html += '</div>';
			return the_html;
}

   /*==== 8) Function Sort By Filter =====*/	 
function get__sort__filter(){
jQuery(document).on("change", ".order__by", function () {
			filter_sort=jQuery(this).val();
			filter_Apply(true);
  });
}
jQuery(document).ready(function () {
jQuery("body").on("change", ".itemsperpage", function () {
	
		filter_Apply(true);
  });
  });


   /*==== 9) Function Sort By Filter numerically =====*/	 
function sorting_result_html_number(arg, sel, elem, order) {
  var $selector = $(sel),
    $element = $selector.children(elem);

  $element.sort(function(a, b) {
    var an = parseInt(a.getAttribute(arg)),
      bn = parseInt(b.getAttribute(arg));

    if (order == 'asc') {
      if (an > bn)
        return 1;
      if (an < bn)
        return -1;
    } else if (order == 'desc') {
      if (an < bn)
        return 1;
      if (an > bn)
        return -1;
    }
    return 0;
  });
  $element.detach().appendTo($selector);
}

   /*==== 10) Function Sort By Filter alphabetically =====*/	 
function sorting_result_html_text(arg, sel, elem, order) {
  var $selector = $(sel),
    $element = $selector.children(elem);


  $element.sort(function(a, b) {
    var nameA = a.getAttribute(arg).toUpperCase(),
      nameB = b.getAttribute(arg).toUpperCase();
    if (order == 'asc') {

      if (nameA < nameB) {
        return -1;
      }
      if (nameA > nameB) {
        return 1;
      }
	} else if (order == 'desc') {
       if (nameA < nameB) {
     	 return 1;
    	}
    	if (nameA > nameB) {
     		 return -1;
    	}
    }
    return 0;
  });
  $element.detach().appendTo($selector);
}

   /*==== 10) Function get Max Price =====*/	 
function get__maxprice(variants){
    var maxprice=0;
    for (k = 0; k < variants.length; k++) {
        if(maxprice<parseFloat(variants[k].price)){
           maxprice = parseFloat(variants[k].price);
        }
   }
  return maxprice;
}

   /*==== 11) Function get Single Price =====*/	 
function get__price(variants){
    var minprice=variants[0].price;
    for (k = 0; k < variants.length; k++) {
        if(minprice>parseFloat(variants[k].price)){
           minprice = parseFloat(variants[k].price);
        }
   }
  return minprice;
}
 
   /*==== 12) Function Apply Filter =====*/	  
function filter_Apply(showTitmer,showProducts=false){
	 filter_start_price=jQuery(".price_start").val();
     filter_end_price=jQuery(".price_end").val();
  jQuery("#loading").show();
  var timevalue=100;
  if(showTitmer){
	timevalue=3000;  
  }
 setTimeout(function(){
  jQuery(".prd__box").each(function() {
	  var $this= jQuery(this);
	  var is_priceshow=false;
	  var is_tagshow=false;
	  
	  //price filter
	  var prdprice=parseFloat($this.attr("data-listing-price"));
	if(prdprice>=parseFloat(filter_start_price) && prdprice<=parseFloat(filter_end_price)){
	  is_priceshow=true;
	}
	 is_priceshow=true;//remove this if want price filter
    
	//tags filter
	if(filter_tags== null || filter_tags== ""){
		is_tagshow=true
	}else{
		var prdtags=$this.attr("data-listing-tags");
		var selectedtagsArr=filter_tags.toString().split(',');
		for(var st = 0; st < selectedtagsArr.length; st++) {		  
		   if(prdtags.indexOf(selectedtagsArr[st]) !== -1)    
		   {
			 is_tagshow=true;
			break;
		   }
		}
	}		
	//is_tagshow=true
	//	final step
	if(is_priceshow && is_tagshow){
	 $this.addClass("isActive");	
	 $this.show();	
	}else{
	$this.removeClass("isActive");	
	$this.hide();
	}
  });
   switch(filter_sort) {
  case "price_asc":
       sorting_result_html_number('data-listing-price', '.products-result', '.prd__box', 'asc');
    break;
  case "price_desc":
       sorting_result_html_number('data-listing-price', '.products-result', '.prd__box', 'desc');
    break;
     case "latest":
       sorting_result_html_number('data-listing-date', '.products-result', '.prd__box', 'desc');
    break;
  case "title_desc":
       sorting_result_html_text('data-listing-title', '.products-result', '.prd__box', 'desc');
    break;
     case "title_asc":
       sorting_result_html_text('data-listing-title', '.products-result', '.prd__box', 'asc');
    break;
  default:
       sorting_result_html_text('data-listing-title', '.products-result', '.prd__box', 'asc');
}
   let url = shopUrl+"/collections/"+col_handle;      
   url = new URL(url);

   // url.searchParams.set('start_price', filter_start_price);
   //url.searchParams.set('end_price', filter_end_price);
   if(filter_sort){
   url.searchParams.set('filter_sort', filter_sort);
   }

    if(filter_tags!=null){
     url.searchParams.set('filter_tags', filter_tags);
   } 
    window.history.pushState({}, '', url);
    make_pagination();
	if(filter_sort || filter_tags!=null || showProducts){
		
		jQuery(".products-subcat").hide();
      if($(".products-result .prd__box.isActive").length!=0){
        jQuery(".products-no-result").hide();
		jQuery(".products-result").show();
		jQuery("#pagination-container").show();
      }else{
        jQuery(".products-result").hide();
		jQuery("#pagination-container").hide();
        jQuery(".products-no-result").show();
      }
      	
		jQuery("#loading").hide();
	}else{
		
		$.ajax({
        url: "/collections/"+col_handle,
        type: "GET",
        dataType: "html",
        success: function (responseHTML) {
            var resposneResult =jQuery(responseHTML).find('.products-subcat').html();
            $('.products-subcat').html(resposneResult);
			console.log(jQuery("body .products-subcat .grid-item").length);
			if(jQuery("body .products-subcat .grid-item").length==0){
				jQuery(".products-subcat").hide();
                 if(jQuery(".products-result .prd__box.isActive").length!=0){
                    jQuery(".products-no-result").hide();
            		jQuery(".products-result").show();
            		jQuery("#pagination-container").show();
                  }else{
                    jQuery(".products-result").hide();
            		jQuery("#pagination-container").hide();
                    jQuery(".products-no-result").show();
                  }
			}else{
			jQuery(".products-subcat").show();
             jQuery(".products-no-result").hide();
			jQuery(".products-result").hide();
			jQuery("#pagination-container").hide();
			//jQuery(".sidebar-tags-container").hide();
			createViewMoreCollection();
			}
			jQuery("#loading").hide();

        }
    });
		
	}
   
  // update_breadcrumbs();
  },timevalue);
}

function dateto_timestamp(theDate){
	const date1 = new Date(theDate);
	return timestamp = date1.getTime();
}

function getsortedoption(optvalue,optTitle){

  if(optvalue == filter_sort) {
  
       return '<option value="'+optvalue+'" selected>'+optTitle+'</option>';
  }else{
       return '<option value="'+optvalue+'">'+optTitle+'</option>';
	}

}
function createTagsHtml(tagdata){
		jQuery(".sidebar-col-tags").html(tagdata);
		jQuery("body").on("change",".tag-item",function(e){
			filter_tags=[];
         $('.tag-item:checked').each(function(index, value) {
			filter_tags.push($(this).val());
		 
		});
		filter_Apply(true);
    });
}
function get_tags_filter(selectedtags){
     
        jQuery("#loading").show();
       setTimeout(function(){
          if(selectedtags== null){
            jQuery(".prd__box").show();
             jQuery("#loading").hide();
            return;
          }
         jQuery(".prd__box").hide();
        jQuery(".prd__box").each(function() {
          	var $this= jQuery(this);
            var prdtags=jQuery(this).attr("data-listing-tags");
          	var selectedtagsArr=selectedtags.toString().split(',');
            for(var st = 0; st < selectedtagsArr.length; st++) {		  
               if(prdtags.indexOf(selectedtagsArr[st]) !== -1)    
               {
                 $this.show();
               	break;
               }
            }     
        });
		
          jQuery(".products-subcat").hide();
          jQuery(".products-result").show();
         jQuery("#loading").hide();
        },3000);
}
function createViewMoreCollection(){
	
  jQuery("body .content-sec").each(function(){
  		var myStr = jQuery(".description",this);
        var myReadmore = jQuery(".read-more",this);
  		if(myStr.prop("scrollHeight") > 225){
		myStr.removeClass("show-more-height");
          myReadmore.show();
  		}
  	});
  	jQuery(".content-sec .read-more").click(function(e){
  		e.preventDefault();
  		var parent__class=jQuery(this).closest('.content-sec');
      if(jQuery(".description",parent__class).hasClass("show-more-height")){
        jQuery(this).text("View More");
      }else{
        jQuery(this).text("View Less");
      }
  		jQuery(".description",parent__class).toggleClass("show-more-height");
  		
  	});
}	
}


/*==== Functions For Product Page =====*/	  
////
 if(isproductPage){

  const priceInterval = setInterval(setCustomPrice2, 100);
 var defaultPrice=jQuery(".total-price .total-money").text();

function setCustomPrice2() {
  if(jQuery("#ymq-price-addons .ymq-price-span").length==1)
  {
    defaultPrice=jQuery(".total-price .total-money").text();
    var newaddprice = parseFloat(jQuery("#ymq-price-addons .ymq-price-span").text().replace(/[^0-9.-]+/g,""));
    var defaultPriceint = parseFloat(defaultPrice.replace(/[^0-9.-]+/g,""));
	var newPrice = newaddprice+defaultPriceint;
    var newPrice = newPrice;

  	jQuery(".cm_prices .price").text(getCurrencyPrice(newPrice));
  }else{
    defaultPrice=jQuery(".total-price .total-money").text();
     var defaultPriceint = parseFloat(defaultPrice.replace(/[^0-9.-]+/g,""));
    var newPrice = defaultPriceint;

  	jQuery(".cm_prices .price").text(getCurrencyPrice(newPrice));
  }
  checkdropdownproduct();
}
   
}
 


// Global function
function getCurrencyPrice(pricetext){
let dollarUS = Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
    });
return dollarUS.format(pricetext);
}
jQuery(document).ready(function(){
	
	jQuery('ul.tabs-items li').click(function(){
		var tab_id = jQuery(this).attr('data-tab');

		jQuery('ul.tabs-items li').removeClass('current');
		jQuery('.tab-content').removeClass('current');

		jQuery(this).addClass('current');
		jQuery("#"+tab_id).addClass('current');
	});

}) 


function update_breadcrumbs(){  
   jQuery.ajax({
    url: window.location.href,
     type: "GET",
        dataType: "html",
        success: function (data) {
            var result = $('.breadcrumb').html($(data).find('.container .breadcrumb').html());
           
    }
  });  
}
function make_pagination(){

  
var items = $(".products-result .prd__box.isActive");
    var numItems = items.length;
    var perPage = parseInt($(".itemsperpage").val());

    items.slice(perPage).hide();

    $('#pagination-container').pagination({
        items: numItems,
        itemsOnPage: perPage,
        prevText: "&laquo;",
        nextText: "&raquo;",
        onPageClick: function (pageNumber) {
            var showFrom = perPage * (pageNumber - 1);
            var showTo = showFrom + perPage;
            items.hide().slice(showFrom, showTo).show();
            console.log("showFrom=="+showFrom);
            console.log("showTo=="+showTo);
            console.log("showTo=="+showTo);
        }
    });
}

jQuery(".main__variant").change(function(){
  //alert('hellotest');
  var $this=jQuery(this);
  var val_handle=$this.val();
  if(val_handle!=""){
      jQuery(".swatch-element."+val_handle+" input[type='radio']").trigger("change");
    $this.next().text("");
  }else{
    $this.next().text("This is a required field.");
  }
});
  

function ymqBeforeAddcartValidate(){
   var isValid=true;
  var i=0;
    jQuery( ".main__variant" ).each(function( index ) {
      if(jQuery(this).val()==""){
        jQuery(this).next().text("This is a required field.");
        isValid=false;
        if(1==0){
          jQuery(this).focus();
        }
        i++;
      }else{
       jQuery(this).next().text("");
      }
    });

    if(isValid){
        return true;
    }else{
      ymq_option.productInstance.validate.validateAll(ymq_option.productInstance.formData, true);

       return false;
       
    }
}
function checkdropdownproduct(){
   var isValid=true;
    jQuery( ".main__variant" ).each(function( index ) {
      if(jQuery(this).val()==""){
        isValid=false;
      }
    });
    if(!isValid){
       jQuery(".cm_prices").hide();
    }else{
        jQuery(".cm_prices").show();
    }
}
function convertToSlug(Text) {
  return Text.toLowerCase()
             .replace(/ /g, '-')
             .replace(/[^\w-]+/g, '');
}
